import { Component, Inject, OnInit } from '@angular/core';
import { SafetyInductionService } from '../../../services/safety-induction.service';
import { FileReaderEvent } from '../../../setup-implement/setup-implement.component';
import { CreateExternalAttendeeVM } from '../../perform-induction';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogData {

}
@Component({
  selector: 'app-dialog-add-attendee',
  templateUrl: './dialog-add-attendee.component.html',
  styleUrls: ['./dialog-add-attendee.component.css']
})
export class DialogAddAttendeeComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogAddAttendeeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _inductionService: SafetyInductionService,) { }

  fName: string;
  lName: string;
  EmailAddress: string;
  Company: string;
  Position: string;
  ImagePreview: string;

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmitClick(): void {
    let params = new CreateExternalAttendeeVM();
    params.Fname = this.fName;
    params.Lname = this.lName;
    params.Company = this.Company;
    params.Position = this.Position;
    params.Email = this.EmailAddress;
    params.Photo = this.ImagePreview;

    this._inductionService.CreateExternalAttendee(params).subscribe(res => {
      
      this.dialogRef.close({ result: true,data: res });
    })
  }

  onFileChanged(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event: any) => { // called once readAsDataURL is completed
        var imageUrl = (event.target["result"]);
        this.ImagePreview = imageUrl;

      }
    }

  }

}
